module.exports = __webpack_public_path__ + "img/kohira.d7e5b22f.jpg";